import { useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { BookOpen, Download, Eye, FileText } from "lucide-react";

const GUIDE = [
  { file: "guida-collaboratori-efferre-crm.pdf", title: "Guida per i Collaboratori", desc: "Pipeline, liste, eventi e inviti, compensi. Sportivo e Ritrattistica in capitoli separati.", tid: "collaboratori" },
  { file: "guida-titolare-efferre-crm.pdf", title: "Guida completa per il Titolare", desc: "Tutte le funzioni: collaboratori, Portfolio, Agenda, Experience, Impostazioni, Controllo.", tid: "titolare", solo: "titolare" },
];

export default function Guida() {
  const { isTitolare } = useAuth();
  const list = GUIDE.filter((g) => isTitolare || g.solo !== "titolare");
  return (
    <div className="space-y-6" data-testid="guida-page">
      <div>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 dark:text-white flex items-center gap-2"><BookOpen className="h-7 w-7 text-primary" /> Guida all'uso</h1>
        <p className="text-slate-500 mt-1">Manuali in PDF con indice cliccabile: tocca un capitolo per andarci, e "torna all'indice" in fondo a ogni pagina.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {list.map((g, i) => (
          <Card key={g.file} data-testid={`guida-card-${g.tid}`} className="p-6 animate-fade-up" style={{ animationDelay: `${i * 80}ms` }}>
            <div className="flex items-start gap-4">
              <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0"><FileText className="h-6 w-6 text-primary" /></div>
              <div className="flex-1 min-w-0">
                <h2 className="font-bold text-slate-900 dark:text-white">{g.title}</h2>
                <p className="text-sm text-slate-500 mt-1">{g.desc}</p>
                <div className="flex flex-wrap gap-2 mt-4">
                  <a data-testid={`guida-open-${g.tid}`} href={`/docs/${g.file}`} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 rounded-full bg-primary text-white px-4 py-2 text-sm font-semibold hover:opacity-90 transition-opacity"><Eye className="h-4 w-4" /> Apri</a>
                  <a data-testid={`guida-download-${g.tid}`} href={`/docs/${g.file}`} download
                    className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 dark:border-slate-700 px-4 py-2 text-sm font-semibold hover:border-primary hover:text-primary transition-colors"><Download className="h-4 w-4" /> Scarica</a>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
